import React, { useState } from 'react';
import { Avatar, Space, Spin } from 'antd';
import Styles from './styles';
import { capitalize, getFirstLetter } from '../../../../utils/text';
import { DeleteOutlined } from '@ant-design/icons';
import { secondsToTime } from '../../../../utils/dateUtils';
import { format } from 'date-fns';

const {
  TextContent,
  CommentLineContainer,
  DetailsContainer,
  Speaker,
  Comment,
  TextContainer,
  Timestamp,
} = Styles;

interface Props {
  speaker: string;
  content: string;
  id: string;
  createdAt: string;
  showDeleteButton: boolean;
  onDelete?: VoidFunction;
}

export const CommentLine: React.FC<Props> = ({
  id,
  speaker,
  content,
  createdAt,
  showDeleteButton = false,
  onDelete,
}) => {
  const [isMessageHovered, setIsMessageHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const speakerLabel = speaker;

  const handleDelete = async () => {
    setIsLoading(true);
    await onDelete?.();
    setIsLoading(false);
  };

  return (
    <Spin spinning={isLoading}>
      <CommentLineContainer
        id={`transcript-row-${id}`}
        onMouseEnter={() => setIsMessageHovered(true)}
        onMouseLeave={() => setIsMessageHovered(false)}
      >
        <Avatar>{capitalize(getFirstLetter(speakerLabel))}</Avatar>
        <TextContent>
          <DetailsContainer title="Click to play" style={{ height: '24px' }}>
            <Speaker id="transcript-speaker">{speakerLabel}</Speaker>
            <Timestamp>{format(new Date(createdAt), 'MM/dd/yyyy HH:mm')}</Timestamp>
            <Space id="comment-actions">
              {showDeleteButton && (
                <span onClick={handleDelete}>
                  <DeleteOutlined
                    style={{
                      cursor: 'pointer',
                      color: '#A6A6A6',
                    }}
                  />
                </span>
              )}
            </Space>
          </DetailsContainer>
          <Comment id="transcript">
            <TextContainer id="transcript-chunk" current={false} selected={false}>
              {content}
            </TextContainer>
          </Comment>
        </TextContent>
      </CommentLineContainer>
    </Spin>
  );
};
